export const CREATE_BOX= 'CREATE_BOX';
export const CREATE_MANAGERS = 'CREATE_MANAGERS';
export const SET_STATUS_LOCK = 'SET_STATUS_LOCK';
export const CANCEL_SAGA = 'CANCEL_SAGA';
export const PULL_REQUEST = 'PULL_REQUEST';
export const CANCEL_SAGA_PULL = 'CANCEL_SAGA_PULL';